import React, { useEffect, useMemo } from 'react';
import CacheBuster from 'react-cache-buster';
import packageInfo from '../package.json';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { BackpackWalletAdapter } from "@solana/wallet-adapter-backpack";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-phantom";
import { Provider } from 'react-redux'
import store from './store'
import {
  WalletModalProvider, WalletMultiButton,
} from '@solana/wallet-adapter-react-ui';
import {
  Routes,
  Route
} from "react-router-dom";

import "./App.css";
import Header from "./Components/Header/Header.jsx";
import Home from "./screens/Home/Home.jsx";
import IdoAdministration from "./screens/IdoAdministration/IdoAdministration.jsx";

import { Toaster } from 'react-hot-toast';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import {getApiUrl, getRpcUrl, doesURLInclude} from './helpers/helper';
import { SolflareWalletAdapter } from '@solana/wallet-adapter-solflare';
import IdoCreateOrEdit from "./screens/IdoCreateOrEdit/IdoCreateOrEdit";
import VaultAdministration from "./screens/VaultAdministration/VaultAdministration";
import InfoCard from "./Components/InfoCard/InfoCard";
import { ReactComponent as WalletNotConnectedIcon} from './images/svg/walletNotConnected.svg';
import UserAdministration from "./screens/UserAdministration/UserAdministration";
import Raffles from "./screens/RaffleAdministration/Raffles";
import ProjectInterest from "./screens/ProjectInterestAdministration/ProjectInterest";
import RaffleCreateOrEdit from "./screens/RaffleEdit/RaffleCreateOrEdit";
import Tutorials from "./screens/TutorialAdministration/Tutorials";
import TutorialCreateOrEdit from "./screens/TutorialEdit/TutorialCreateOrEdit";
import RankingAdministration from "./screens/RankingAdministration/RankingAdministration";
import MissionsList from "./screens/MissionsList/MissionsList";
import MissionCreateOrEdit from "./screens/MissionEdit/MissionCreateOrEdit";

// Default styles that can be overridden by your app
require('@solana/wallet-adapter-react-ui/styles.css');

export const PATH_HOME = '/';
export const PATH_IDO_ADMINISTRATION = '/idos';
export const PATH_EDIT_IDO = '/idos/:id';
export const PATH_VAULT_ADMINISTRATION = '/vault';
export const PATH_USER_ADMINISTRATION = '/users';
export const PATH_RAFFLE_ADMINISTRATION = '/raffle';
export const PATH_EDIT_RAFFLE = '/raffle/:id';
export const PATH_PROJECT_INTEREST = '/projectInterest';
export const PATH_TUTORIAL_ADMINISTRATION = '/tutorial';
export const PATH_EDIT_TUTORIAL = '/tutorial/:id';
export const PATH_RANKING_ADMINISTRATION = '/ranking';
export const PATH_MISSION_ADMINISTRATION = '/mission';
export const PATH_EDIT_MISSION = '/mission/:id';

function App() {
  const location = useLocation();
  const network = WalletAdapterNetwork.Mainnet;
  const endpoint = getRpcUrl();
  const wallets = useMemo(() => [
    new PhantomWalletAdapter(),
    new BackpackWalletAdapter(),
    new SolflareWalletAdapter()
  ], [network]);

  const [provider, setProvider] = useState();
  const [authorized, setAuthorized] = useState(false);

  return (
    <CacheBuster currentVersion={packageInfo.version} isEnabled>
      <ConnectionProvider
        endpoint={endpoint}
      >
        <WalletProvider wallets={wallets} autoConnect>
          <WalletModalProvider>
            <Provider store={store}>
              <Header setProvider={setProvider} provider={provider} authorized={authorized} setAuthorized={setAuthorized} />
              {!authorized && <InfoCard
                text={provider?.wallet.publicKey == null ? connectWalletText() : connectNotAuthorizedWalletText() }
                title={connectWalletTitle()}
                icon={WalletNotConnectedIcon} />}
              {authorized && <Routes location={location} key={location.pathname}>
                  <Route path={PATH_HOME} exact element={<Home />} />
                  <Route path={PATH_IDO_ADMINISTRATION} exact element={<IdoAdministration />} />
                  <Route path={PATH_EDIT_IDO} element={<IdoCreateOrEdit provider={provider} />} />
                  <Route path={PATH_VAULT_ADMINISTRATION} exact element={<VaultAdministration provider={provider} />} />
                  <Route path={PATH_USER_ADMINISTRATION} exact element={<UserAdministration />} />
                  <Route path={PATH_RAFFLE_ADMINISTRATION} exact element={<Raffles />} />
                  <Route path={PATH_EDIT_RAFFLE} exact element={<RaffleCreateOrEdit provider={provider} />} />
                  <Route path={PATH_PROJECT_INTEREST} exact element={<ProjectInterest />} />
                  <Route path={PATH_TUTORIAL_ADMINISTRATION} exact element={<Tutorials />} />
                  <Route path={PATH_EDIT_TUTORIAL} exact element={<TutorialCreateOrEdit provider={provider} />} />
                  <Route path={PATH_RANKING_ADMINISTRATION} exact element={<RankingAdministration />} />
                  <Route path={PATH_MISSION_ADMINISTRATION} exact element={<MissionsList />} />
                  <Route path={PATH_EDIT_MISSION} element={<MissionCreateOrEdit />} />
              </Routes>}
              <Toaster />
            </Provider>
          </WalletModalProvider>
        </WalletProvider>
      </ConnectionProvider>
    </CacheBuster>
  );
}

export default App;

export const connectWalletTitle = () => {
  return (
    <h5>
      Connect authorized wallet
    </h5>
  );
}

export const connectWalletText = () => {
  return (
    <>
      <p>
        To enter this page you need to connect your authorized Solana wallet. Please use the Select wallet button to connect.
      </p>
      <div className='connectWalletModalWrapper'>
        <WalletMultiButton/>
      </div>
    </>

  );
}

export const connectNotAuthorizedWalletText = () => {
  return (
    <>
      <p>
       This wallet is not authorized, please Routes wallet or contact support
      </p>
      <div className='connectWalletModalWrapper'>
        <WalletMultiButton/>
      </div>
    </>

  );
}

